import React, { useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import hh from '@/assets/images/hhshare.jpg'
import { sendPhoneCode } from '@/utils/sendPhoneCode'
import { isPhone} from '@/utils/utils'
import './index.scss'
const mapStateToProps = (state) => ({
    tenant: state.getIn(['tenantReducer', 'tenant']),
})

const JoinFleet = (props) => {
    let { tenant,history } = props;
    const handleGetCash = () => {
        //发送手机验证码
        // if (isPhone(inputRef.current.value) && inputdrivername.current.value) {
            if (isPhone(inputRef.current.value)) {
            sendPhoneCode(inputRef.current.value)
                .then((data) => {
                    let { errorCode, errorMsg } = data.data
                    if (errorMsg === '请不要频繁获取验证码') {
                        inputRef.current.value = ''
                        inputRef.current.placeholder = '请不要频繁操作,1分钟之后重新获取'

                    } else if (errorMsg === 'SUCCESS' && errorCode === 0) {
                        history.push({
                            // pathname: `/joinfleetverify/${inputRef.current.value}/${inputdrivername.current.value}`
                            pathname: `/joinfleetverify/${inputRef.current.value}`
                        })
                    }
                })
        } else {
            inputRef.current.value = ''
            inputRef.current.placeholder = '请输入正确手机号'
        }

    }
    useEffect(() => {
        document.title ='邀请您加入车队'
        return () => {
            document.title =''
        }
    },[])
    let inputRef = useRef();
    let inputdrivername = useRef()
    return (
        <div className="join-fleet__box">
            <div className="join-fleet__tit">
                您的好友邀请您加入车队成为“{tenant}”司机
            </div>
            <div className="join-fleet-banner">
                <img src={hh} alt="" />
            </div>
            <section>
                <div className="phone-input__box">
                    {/* <input type="text" placeholder="请输入司机名称" ref={inputdrivername} /> */}
                    <input type="number" placeholder="请输入您的手机号" ref={inputRef} />
                </div>
                <footer>
                    <button onClick={handleGetCash} style={(React.colorConfig ? React.colorConfig.buttonBg : {})}>加入车队</button>
                </footer>
            </section>
        </div>
    )
}
export default connect(mapStateToProps)(JoinFleet)
